"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M7.311,20.571c-3.227,0-3.67-2.906-3.871-4.142l-.03-.181c-.03-.221-.06-.432-.08-.643H3.3v-.694c0-.372.01-.734.02-1.066A17.738,17.738,0,0,1,3.7,10.94a19.5,19.5,0,0,1,.8-2.855l.231-.643.01.01c.06-.151.121-.3.191-.442a11.533,11.533,0,0,1,2-3.237A9.236,9.236,0,0,1,9.724,1.63,10.457,10.457,0,0,1,13.716.594a10.681,10.681,0,0,1,3.318.282,7.315,7.315,0,0,1,4.353,3.046,7.781,7.781,0,0,1,1.327,3.589c.03.292.03,1.186.02,2.152l-.01,2.674c0,3.911-6.907,6.294-12.7,7.6-.161.04-.282.06-.352.08a.606.606,0,1,1-.292-1.176c.07-.02.2-.05.382-.09,7.47-1.689,11.743-4.022,11.743-6.414l.01-2.684c0-.573.01-1.769-.02-2.021A6.555,6.555,0,0,0,20.371,4.6a6.143,6.143,0,0,0-3.65-2.554A9.189,9.189,0,0,0,13.786,1.8a9.237,9.237,0,0,0-3.529.9,8.019,8.019,0,0,0-2.423,1.87,10.6,10.6,0,0,0-1.79,2.916c-.06.131-.111.261-.171.392a4.672,4.672,0,0,0,.674.02A4.127,4.127,0,0,0,9.473,6.868a2.09,2.09,0,0,1,2.292-.623,2.227,2.227,0,0,1,1.227,2.182c0,1.94-1.619,3.459-2.694,4.464a9,9,0,0,1-5.751,2.6h0c.01.181.04.362.06.543l.03.191c.241,1.578.654,3.117,2.664,3.117a.605.605,0,0,1,.6.6A.6.6,0,0,1,7.311,20.571ZM4.9,11.181a19.26,19.26,0,0,0-.372,3.107,7.927,7.927,0,0,0,4.936-2.272c1.217-1.136,2.312-2.272,2.312-3.579,0-.533-.181-.945-.473-1.066-.271-.111-.623.02-.965.362A5.27,5.27,0,0,1,6.588,9.12a4.815,4.815,0,0,1-1.126-.08c-.1.332-.211.684-.312,1.066S4.979,10.829,4.9,11.181Zm13.4,2.091h0a2.1,2.1,0,0,1-.01-4.2,2.168,2.168,0,0,1,1.5.623A2.09,2.09,0,0,1,18.3,13.272Zm-.01-1.217h0a.893.893,0,0,0,.885-.885.875.875,0,0,0-.261-.623.836.836,0,0,0-.623-.261.885.885,0,1,0,0,1.769Z",
    transform: "translate(-3.3 -0.571)",
    fill: "#fff"
  })
});

var MotorIcon = function MotorIcon(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '0.9 -0.2 17.5 20.3';
  }

  if (!mainDimension) {
    mainDimension = 'both';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "MotorIcon-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = MotorIcon;
exports["default"] = _default;

//# sourceMappingURL=index.js.map